import { useEffect } from 'react'
import { GAEventName } from '../interfaces/googleAnalytics'
import { useGoogleAnalytics } from '../providers/GoogleAnalyticsProvider'
import { useWalletProperties } from '../state'
import useBalances from './useBalances'
import useWallet from './useWallet'

export const useWalletFundedTracker = () => {
  const { balances, isEmptyWallet } = useBalances()
  const { fireEvent } = useGoogleAnalytics()
  const { wallet } = useWallet()
  const { walletFundingBaselines, setWalletFundingBaseline } = useWalletProperties()

  const walletId = wallet?.principalId

  useEffect(() => {
    if (!walletId || balances.length === 0) return

    const baseline = walletFundingBaselines[walletId]

    if (!baseline) {
      setWalletFundingBaseline(walletId, isEmptyWallet ? 'empty' : 'funded')
      return
    }

    if (baseline === 'empty' && !isEmptyWallet) {
      const [largest] = balances
        .filter((item) => item.balance > 0n)
        .sort((a, b) => (b.usdBalance || 0) - (a.usdBalance || 0))

      fireEvent(GAEventName.WALLET_FUNDED, {
        first_token: largest?.token?.symbol ?? 'unknown',
        usd_value: largest?.usdBalance ?? 0,
      })

      setWalletFundingBaseline(walletId, 'funded')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletId, balances, isEmptyWallet, walletFundingBaselines])
}

export default useWalletFundedTracker
